const Cell = ({ dispatch, ...props }) => (
	<td className='checklist-td center-aligned'>
		<div className='custom-control custom-control-info custom-radio mt-3 '>
			<input
				className='custom-control-input '
				type='radio'
				id={props.inputRadioId}
				value={props.value}
				checked={parseInt(props.value) === parseInt(props.item.value)}
				onChange={(event) =>
					dispatch(
						props.onChangeItem(
							event.target.value,
							props.sectionId,
							props.item.id
						)
					)
				}
				disabled={props.status === 'submit'}
			/>
			<label
				className='custom-control-label'
				htmlFor={props.inputRadioId}
			></label>
		</div>
	</td>
)

export default Cell
